import React, { Component } from 'react';
import { Link } from 'react-router';
import logo from './assets/startupLogo.png';
import styles from './styles.scss';

class Navigation extends Component {
  state = {
    navSticky: false
  };

  render() {
    const { navSticky } = this.state;

    return (
      <div>
        <nav className={`startup-nav ${styles.header} ${navSticky ? styles.scrolling : ''}`}>
          <div className="row">
            <div className={`${styles.responsiveNavWidth} col-lg-10 col-md-12 col-center`}>
              <div className="container-fluid">
                <Link to="/0-to-startup" className={styles.brand}>
                  <img src={logo} className={styles.logo} alt="logo" />
                </Link>
                <Link to='/' target="_blank" className={`${styles.byDC} light-italics ls1`}>by DesignCue</Link>
                <Link to={{ pathname: '/startup-application'}} className={`${styles.button} btn-dc-blue btn pull-right mt20`}>
                  APPLY NOW
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </div>
    );
  }

  componentDidMount = () => {
    window.addEventListener('scroll', this.onScrollHandler);
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScrollHandler = (event) => {
    const body = event.srcElement && event.srcElement.body;
    const nav = event.srcElement && event.srcElement.body.getElementsByClassName('startup-nav')[0];
    const aboveTheFold = event.srcElement && event.srcElement.body.getElementsByClassName('above-the-fold')[0];

    if (Boolean(aboveTheFold)) {
      if (scrolledPastElement(aboveTheFold, body)) {
        this.setState({
          navSticky: true
        });
      } else {
        this.setState({
          navSticky: false
        });
      }
    } else {
      if (scrolledPastElement(nav, body)) {
        this.setState({
          navSticky: true
        });
      } else {
        this.setState({
          navSticky: false
        });
      }
    }

    // function getPosition(e) {
    //   var isNotFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') === -1;
    //   var y = 0;
    //   if (isNotFirefox) {
    //     while(e) {
    //       y += (e.offsetTop - e.scrollTop - e.style.height);
    //       if (isNotFirefox) {
    //         y += (e.clientTop - e.style.height);
    //       } else {
    //       }
    //       e = e.offsetParent;
    //     }
    //   } else {
    //     y = -1;
    //   }
    //   return y;
    // }

    function scrolledPastElement(element, body) {
      var isNotFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') === -1;
      if (isNotFirefox) {
        return element.clientHeight < body.scrollTop;
      } else {
        return true;
      }
    }
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/StartupNavigation/index.js